import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import Restaurant from '@components/restaurant/models/Restaurant';

interface RestaurantHeaderSkeletonProps {
}

const RestaurantHeaderSkeleton: React.FC<RestaurantHeaderSkeletonProps> = ({  }) => {
    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-start"}
            width={"100%"}>
            <Typography fontWeight={600}>
                <Skeleton width={60}/>
            </Typography>
            <Typography variant='subtitle2'>
                <Skeleton width={90}/>
            </Typography>
        </Box>
    )
}

export default RestaurantHeaderSkeleton;